<template>
  <b-modal id="updateCrystallizeModal" ref="updateCrystallizeModal" no-stacking @hidden="closeModal">
    <template slot="modal-title">{{ $t('title') }}</template>
    <p>{{ $t('confirm') }}</p>
    <div slot="modal-footer" class="col-md-12">
      <b-button variant="primary" class="float-lg-right" @click="updateCrystallize">{{ $t('action') }}</b-button>
      <b-button variant="secondary" class="float-lg-left" @click="closeModal">{{ $t('cancel') }}</b-button>
    </div>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex';
  import CrystallizeService from '@/services/CrystallizeService';

  export default {
    name: 'UpdateCrystallizeModal',
    computed: {
      ...mapGetters('products', ['product']),
    },
    methods: {
      closeModal() {
        this.$bvModal.hide('updateCrystallizeModal')
      },
      async updateCrystallize () {
        try {
          await CrystallizeService.updateProduct(this.product);
          this.$bvToast.toast(this.$t('success'), {
            title: this.$t('title'),
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 2000
          });
        } catch (error) {
          this.$bvToast.toast(this.$t('error'), {
            title: this.$t('title'),
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 2000
          });
        } finally {
          this.closeModal()
        }
      },
    },
    i18n: {
      messages: {
        en: {
          'title': 'Send to Crystallize',
          'confirm': 'Do want to update this product in Crystallize?',
          'success': 'Successfully updated product',
          'error': 'Something went wrong',
          'action': 'Send',
        },
        nb: {
          'title': 'Send til Crystallize',
          'confirm': 'Vil du sende dette produktet til Crystallize?',
          'success': 'Vellykket oppdatering av produktet',
          'error': 'Noe gikk galt, dessverre',
          'action': 'Send',
        }
      }
    }
  }
</script>

